import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities model
import { getTags } from 'models/tags'; // Importing getTags model
import { getPositions } from 'models/positions'; // Importing getPositions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { providersCasino } from 'config/config'; // Importing providersCasino configuration
import { gamesCasino } from 'config/config'; // Importing gamesCasino configuration

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text', // Datepicker input
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        const center_left = {
            // Center left section for provider selection
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'combo', // Combo box for selecting provider
                    name: 'ProviderId',
                    localId: 'provider:combo',
                    label: _('Proveedor'), // Label for provider
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: {
                        body: {
                            dataFeed: function (text) {
                                // Function to fetch provider data
                                var vthis = this; // Reference to the current context
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect', // API endpoint
                                            '{"Filter":"' + text + '"}', // Request body
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error handling
                                                    webix.message('Error! '); // Display error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success handling
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        vthis.parse(resp.Data); // Populate combo with data
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        const center_right = {
            // Center right section for product selection
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'combo', // Combo box for selecting product
                    name: 'ProductId',
                    label: _('Producto'), // Label for product
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: {
                        body: {
                            dataFeed: function (text) {
                                // Function to fetch product data
                                var vthis = this; // Reference to the current context
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/GamesCasinoSelect', // API endpoint
                                            '{"Filter":"' + text + '"}', // Request body
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error handling
                                                    webix.message('Error! '); // Display error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success handling
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        vthis.parse(resp.Data); // Populate combo with data
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        const right = {
            // Right section (currently empty)
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        const upper_section = {
            // Upper section containing the form fields
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right], // Combine left, center left, and center right sections
                },
            ],
        };

        const buttons = {
            // Button section for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event with form data
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
